import React from 'react'
import { connect } from 'react-redux'
import { Menu, Dropdown } from 'antd'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { filterMenuByPermissions } from 'services/menu/menuPermissionFilter'
import styles from './style.module.scss'

const mapStateToProps = ({ menu, user }) => ({
  menuData5: menu.menuData5,
  userPermissions: user.permissions || [],
})
@connect(mapStateToProps)
class MenuPages extends React.Component {
  menu = () => {
    const { menuData5 = [], userPermissions } = this.props
    const filteredMenu = filterMenuByPermissions(menuData5, userPermissions)
    return (
      <Menu selectable={false} style={{ width: 200 }}>
        {filteredMenu.map(item => {

          if (!item.category && item.children) {
            return (
              <Menu.SubMenu
                title={
                  <span>
                    <i className={`${item.icon} mr-2`} />
                    <FormattedMessage id={item.key} />
                  </span>
                }
                key={item.key}
              >
                {item.children.map(subItem => {
                  return (
                    <Menu.Item key={subItem.key}>
                      <Link to={subItem.url}>
                        <FormattedMessage id={subItem.key} />
                      </Link>
                    </Menu.Item>
                  )
                })}
              </Menu.SubMenu>
            )
          }

          if (!item.category && item.url) {
            return (
              <Menu.Item key={item.key}>
                <Link to={item.url}>
                  <i className={`${item.icon} mr-2`} />
                  <FormattedMessage id={item.key} />
                </Link>
              </Menu.Item>
            )
          }

          return null
        })}
      </Menu>
    )
  }

  render() {
    return (
      <Dropdown overlay={this.menu} trigger={['click']} placement="bottomLeft">
        <div className={styles.dropdown}>
          <i className={`${styles.icon} fe fe-file-text`} />
          <span className="d-none d-lg-inline-block">
            <FormattedMessage id="setting" />
          </span>
        </div>
      </Dropdown>
    )
  }
}

export default MenuPages
